import React from 'react';
import {
  Body,
  designSystemToken,
  Headline,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './OffPlatformExpiredLink.module.scss';

/**
 * Reviewer-facing empty state for an off-platform share link whose token is
 * missing, malformed, or expired (surfaced via the OFF_PLATFORM_INVALID_TOKEN
 * sentinel). There is intentionally no link back into AWAR and no "log in" CTA
 * — an off-platform reviewer has no account.
 *
 * NOTE: exact copy is pending design review (USE-444).
 */
function OffPlatformExpiredLink() {
  return (
    <div className={styles.container} data-testid="off-platform-expired-link">
      <div className={styles.content} role="status">
        <Headline
          component="h1"
          size="md"
          color={designSystemToken('semantic.fg.primary')}
        >
          {translate('This link has expired')}
        </Headline>
        <Body size="md" color={designSystemToken('semantic.fg.secondary')}>
          {translate(
            'Please request a new one from someone at your organization with access to Popular Pays.'
          )}
        </Body>
      </div>
    </div>
  );
}

export default OffPlatformExpiredLink;
